export function clickOutside(node) {
   
    const handleClick = event => {
        const isHead = event.path && event.path[1] && event.path[1].id === 'header-store-type-container';
        if (node && !node.contains(event.path[1]) && !isHead && !event.defaultPrevented) {
            node.dispatchEvent(
                new CustomEvent('click_outside', node)
            )
        }
    }
    document.addEventListener('click', handleClick, true);
    return {
            destroy() {
                document.removeEventListener('click', handleClick, true);
            }
        }
}